import axios from 'axios';
import {getItem} from '../utils/storage';
import { getApiDomain } from '../agent/config';
import getV2AxiosInstance from '../utils/v2Axios.js';

export function setServicesList(data){
    return {
        type: 'SET_SERVICES_LIST',
        payload: data
    };
}

export function setAllServicesList(data){
    return {
        type: 'SET_ALL_SERVICES_LIST',
        payload: data
    };
}

export function setServicesListByClient(data) {
  return {
    type: 'SET_SERVICES_LIST_BY_CLIENT',
    payload: data
  };
}

function handleResponse(response){
  if(response.status==200){
    return response;
  }else{
    let error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

export function getServicesList(){
    return (dispatch) => {
      return getV2AxiosInstance()
        .post("/bridge/en/invoxapi/Agent", {
          action: "listServices",
          params: { agent_id: localStorage.getItem("agent_id") },
        })
        .then(handleResponse)
        .then((data) => {
          if(data.data.response && data.data.response.items.length > 0){
          return dispatch(setServicesList((data.data.response.items)))
          }
        });
    };
}

export function getServicesListByClient(){
    return dispatch => {
      return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Client", {
        action: "listServicesByClient",
        params: { agent_id: localStorage.getItem("agent_id") },
      }).then(data => {
        dispatch(setServicesListByClient(data.data.response.items));
        return handleResponse(data);
      })
    };
}

export function getServicesListByAgent(){
    return (dispatch) => {
      return getV2AxiosInstance()
        .post("/bridge/en/invoxapi/Agent", {
          action: "listServices",
          params: { agent_id: localStorage.getItem("agent_id") },
        })
        .then((data) => {
          if(data.data.response && data.data.response.items.length > 0){
          dispatch(setAllServicesList(data.data.response.items));
          return handleResponse(data);
          }
        });
    };
}

export function setService(payload){
    return dispatch => {
      return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Call", {
        action: "setService",
        params: { agent_id: localStorage.getItem("agent_id"),
        service_id: payload.service_id,
        call_id: payload.call_id,
       },
      }).then(handleResponse)
    };
}

export function setDefaultService(payload){
    return dispatch => {
      return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Agent", {
        action: "setDefaultService",
        params: { agent_id: localStorage.getItem("agent_id"),
        service_id: payload.service_id,
       },
      }).then(handleResponse)
    };
}



// WEBPACK FOOTER //
// ./src/actions/outgoingService.js